<template>
    <el-drawer title="选择石化订单" :visible.sync="drawerVisible" append-to-body direction="rtl" size="86%">
    <div class="drawer-container">
      <div class="drawer-content">
          <el-tabs v-model="activeIndex" class="tabs-area" type="card" @tab-click="handleClick">
              <el-tab-pane label="石化采购意向单" name="0"></el-tab-pane>
              <el-tab-pane label="石化采购订单" name="1"></el-tab-pane>
          </el-tabs>

          <div class="search-box">
          <ESearch
                  :data="listQuery"
                  :field-list="activeIndex === '0' ? fieldList : mallOrderFieldList"
                  :list-type-info="listTypeInfo"
                  :width="showWidth"
                  @handleFilter="handleFilter"
                  @handleReset="handleReset"
          ></ESearch>
        </div>
        <div class="table-wrapper">
          <div class="table-content">
            <div class="table-left">
              <div class="choose-total"></div>
              <div class="list-box">
                <TableList
                        ref="leftTableRef"
                        :table-data="leftTableData"
                        :table-label="activeIndex === '0' ? leftTableLabel : leftMallOrderTableLabel"
                        row-key="id"
                        :loading="tableLoading"
                        selection-show
                        @handleSelectionChange="leftHandleSelectionChange"
                >
                  <template #stockAffirmHeader>
                      <span>石化采购意向单编号</span>
                    <el-tooltip class="item" effect="dark" placement="top-start">
                      <div slot="content">
                        常规阀门：收到框架协议订货函、询比价中选通知或中标通知后，立即启动原材料采购与排产计划。
                      </div>
                      <div class="icon-question">?</div>
                    </el-tooltip>
                  </template>
                  <template #erpNoHeader>
                    <span>ERP订单号</span>
                    <el-tooltip class="item" effect="dark" placement="top-end">
                      <div slot="content">特殊材料阀门：完成技术澄清并签订合同后，启动原材料采购与排产计划。</div>
                      <div class="icon-question">?</div>
                    </el-tooltip>
                  </template>
                  <template #operate="{ scope: { row } }">
                    <eui-btn type="link" font-size="12px" @click="handleView(row)">查看详情</eui-btn>
                  </template>
                </TableList>
              </div>

              <div class="pagination">
                <el-pagination
                  :pager-count="5"
                  layout="total, prev, pager, next"
                  :current-page="listQuery.pageNum"
                  :total="total"
                  :page-size.sync="listQuery.pageSize"
                  prev-text="上一页"
                  next-text="下一页"
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                ></el-pagination>
              </div>
            </div>
            <div class="table-center">
              <eui-btn @click="addSelectedList">
                添加
                <eui-icon icon="eicon-arrow-right"></eui-icon>
              </eui-btn>
              <eui-btn style="margin: 10px 0 0 0" @click="deleteCompany">
                <eui-icon icon="eicon-arrow-left"></eui-icon>
                删除
              </eui-btn>
            </div>
            <div class="table-right">
              <div class="choose-total">{{ `当前选择  ${rightTableData.length}条` }}</div>
              <div class="list-box">
                <TableList
                        ref="rightTableRef"
                        :table-data="rightTableData"
                        :table-label="rightTableLabel"
                        row-key="id"
                        :showHeader="false"
                        selection-show
                        max-height="397"
                        @handleSelectionChange="rightHandleSelectionChange"
                >
                    <template v-slot:idOrNo="{scope:{row}}">
                        <span>{{row.stockAffirmId ? row.stockAffirmId : row.orderNo}}</span>
                    </template>
                </TableList>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="drawer-footer">
        <eui-btn @click="onCancel">取消</eui-btn>
        <eui-btn @click="onConfirm">确定</eui-btn>
      </div>
    </div>
        <!-- 查看详情-->
        <detail-dialog
                v-if="materialsVisible"
                :viewDetailVisible.sync="materialsVisible"
                :id="id"
                :type="type"></detail-dialog>
  </el-drawer>
</template>

<script>
import ESearch from '@/modules/projectA/components/common/e-search';
import TableList from '@/modules/projectA/components/common/e-table-list.vue';
import api from '@/modules/projectA/api/order';
import _ from 'lodash';
import {
  listQuery,
  stockDrawerFieldList as fieldList,
  mallOrderFieldList,
  leftStockDrawerTableLabel as leftTableLabel,
  leftMallOrderTableLabel,
  rightOrderDrawerTableLabel as rightTableLabel,
  listTypeInfo,
  getHalfYearRange,
} from '../../common/stockOrder';
import MaterialsDialog from './MaterialsDialog.vue';
import detailDialog from '../../../order/common/detailDialog.vue';

export default {
  components: {ESearch, TableList, MaterialsDialog, detailDialog},
  props: {
    visible: Boolean,
    selectTableData: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      id: '',
      type: '',
      activeIndex: '0',
      tableLoading: false,
      listQuery,
      leftTableLabel,
      leftMallOrderTableLabel,
      total: 0,
      listTypeInfo,
      fieldList,
      mallOrderFieldList,

      showWidth: {
        labelWidth: 130,
        itemWidth: 200,
      },

      leftTableData: [],
      leftTableDataAll: [],
      leftSelectedList: [],

      rightTableLabel,
      rightTableData: [],
      rightSelectedList: [],
      materialsVisible: false,
      purchasePlanId: -1,
    };
  },
  computed: {
    drawerVisible: {
      get() {
        return this.visible;
      },
      set(value) {
        this.$emit('update:visible', value);
      },
    },
  },
  watch: {
    visible: {
      immediate: true,
      deep: true,
      handler: function (newVal) {
        if (newVal) {
          const [createDateBegin, createDateEnd] = getHalfYearRange();
          this.listQuery.createDateBegin = createDateBegin;
          this.listQuery.createDateEnd = createDateEnd;
          this.listQuery.createTime = [createDateBegin, createDateEnd];
          this.cloneListQuery = _.cloneDeep(this.listQuery);
          this.dealSelect(this.listQuery, 'queryOptionPage');
          this.rightTableData = [...this.selectTableData];
        }
      }
    },
  },
  methods: {
    handleClick(val) {
      this.listQuery.pageNum = 1;
      this.activeIndex = val.index;
      this.dealSelect();
    },
    dealSelect() {
      if (this.activeIndex === '0') {
        this.getList(this.listQuery, 'queryOptionPage');
      } else if (this.activeIndex === '1') {
        this.getList(this.listQuery, 'mallOrderQueryOptionPage');
      }
    },
    handleView(row) {
      const {id, type} = row;
      this.id = id;
      this.type = type;
      this.materialsVisible = true;
    },
    onCancel() {
      this.drawerVisible = false;
      this.listQuery = { ...this.cloneListQuery };
    },
    async getList(params, methodName) {
      try {
        this.tableLoading = true;
        const {data = {}, code} = await api[methodName](params);
        if (code === '200') {
          const { records = [], total = 0 } = data;
          this.leftTableData = [...records];

          this.leftTableData.forEach(item => {
            if (this.activeIndex === '0') {
              this.$set(item, 'type', 1)
            } else {
              this.$set(item, 'type', 2)
            }
          })

          this.total = total;
          this.$nextTick(() => {
            this.$refs.leftTableRef?.$refs.table.clearSelection();
          });
        }
      } catch (error) {
        console.error(error);
        // this.leftTableData = [];
      } finally {
        this.tableLoading = false;
      }
    },
    // 都需要进行字段适配
    handleCurrentChange(val) {
      this.listQuery.pageNum = val;
      this.dealSelect();
    },
    handleSizeChange(val) {
      this.listQuery.pageNum = 1;
      this.listQuery.pageSize = val;
      this.dealSelect();
    },
    handleFilter(val) {
      this.listQuery = { ...val };
      const {submitTime, createTime} = val;
      if (createTime && createTime.length > 0) {
        this.listQuery.createDateBegin = createTime[0];
        this.listQuery.createDateEnd = createTime[1];
      } else {
        this.listQuery.createDateBegin = null;
        this.listQuery.createDateEnd = null;
      }
      if (submitTime && submitTime.length > 0) {
        this.listQuery.submitTimeBegin = submitTime[0];
        this.listQuery.submitTimeEnd = submitTime[1];
      } else {
        this.listQuery.submitTimeBegin = null;
        this.listQuery.submitTimeEnd = null;
      }
      this.listQuery.pageNum = 1;
      this.dealSelect();
    },
    handleReset() {
      this.listQuery = {
        ...this.cloneListQuery,
      };
      this.dealSelect();
    },

    leftHandleSelectionChange(val) {
      this.leftSelectedList = val;
    },
    rightHandleSelectionChange(val) {
      this.rightSelectedList = val;
    },
    deleteCompany() {
      const ids = this.rightSelectedList.map((item) => item.id);

      this.rightTableData = this.rightTableData.filter((item) => !ids.includes(item.id));

      this.$nextTick(() => {
        this.$refs.rightTableRef.$refs.table.clearSelection();
      });
    },
    // 添加供应商
    addSelectedList() {
      const rightTableData = this.isCheckedAll
        ? [...this.selectedAllData, ...this.rightTableData]
        : [...this.rightTableData, ...this.leftSelectedList];
      const obj = {};

      const resultTableData = rightTableData.reduce(function (item, next) {
        obj[next.id] ? '' : (obj[next.id] = true && item.push(next));
        return item;
      }, []);
      if (resultTableData.length > 500) {
        this.$message.warning('最500条');
        return;
      }
      this.rightTableData = resultTableData;
    },

    async onConfirm() {
      // if (this.rightTableData.length === 0) {
      //   this.$message.warning('请选择石化采购意向单');
      //   return;
      // }
      this.$emit('getPurchasePlanList', this.rightTableData);
      this.onCancel();
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .el-drawer__body {
  min-height: 0;
}
::v-deep .icon-question {
  height: 18px;
  width: 18px;
  line-height: 18px;
  text-align: center;
  border-radius: 50%;
  border: 1px solid #c5c5c5;
  color: #c5c5c5;
  display: inline-block;
  margin-left: 10px;
}
.drawer-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  .drawer-content {
    flex: 1;
    overflow-y: auto;
    min-height: 0;
    .table-wrapper {
      flex: 1;
      .table-content {
        display: flex;
        padding: 0 10px;
        max-width: 100%;
        width: 100%;
        .table-left {
          flex: 1;
          min-width: 0;
        }
        .table-center {
          flex: none;
          align-self: center;
          text-align: center;
          width: 100px;
        }
        .table-right {
          min-width: 0;
          flex-shrink: 0;
          max-width: 420px;
        }

        .list-box {
          margin-top: 10px;
          max-width: 100%;
        }
        .add-sup {
          color: #0064c8;
          cursor: pointer;
          &:hover {
            text-decoration: underline;
          }
        }

        .del-btn {
          color: #f0250f;
          cursor: pointer;
          &:hover {
            text-decoration: underline;
          }
        }
      }
    }
  }
  .drawer-footer {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 50px;
  }
  .choose-total {
    height: 22px;
  }
}
</style>
